import { defineMessages } from 'react-intl';

const messages = defineMessages({
  contacts_widget: {
    id: 'contacts_widget',
    defaultMessage: 'Contatti',
  },
  contacts_widget_add_message: {
    id: 'contacts_widget_add_message',
    defaultMessage: 'Aggiungi un contatto',
  },
  contacts_widget_contact_type: {
    id: 'contacts_widget_contact_type',
    defaultMessage: 'Etichetta contatto',
  },
  contacts_widget_contact_value: {
    id: 'contacts_widget_contact_value',
    defaultMessage: 'Contatto',
  },
  contacts_widget_contact_description: {
    id: 'contacts_widget_contact_description',
    defaultMessage: 'Descrizione contatto',
  },
});

const contactsSchema = ({ intl }) => {
  const schema = {
    title: intl.formatMessage(messages.contacts_widget),
    addMessage: intl.formatMessage(messages.contacts_widget_add_message),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['type', 'value', 'description'],
      },
    ],
    properties: {
      type: {
        title: intl.formatMessage(messages.contacts_widget_contact_type),
      },
      value: {
        title: intl.formatMessage(messages.contacts_widget_contact_value),
      },
      description: {
        title: intl.formatMessage(messages.contacts_widget_contact_description),
      },
    },
    required: ['title', 'value'],
  };

  return schema;
};

export default contactsSchema;
